<template>
    <div class='ItemListTable' :class='ClassObj'>
        <table class='table'>
            <thead>
            <tr>
                <th class='ItemHeader' v-for='(header, idx) in headers' :key='idx'><span>{{header}}</span></th>
            </tr>
            </thead>
            <tbody>
                <tr v-for='(item, itIdx) in items' :key='itIdx'>
                    <th>
                        <label class="form-checkbox">
                        <input class='listTable-class' type='checkbox' :value='itIdx' v-model='selected'>
                            <i class="form-icon"></i>
                        </label>
                    </th>
                    <td v-for='(value, vidx) in item' :key='vidx'>
                        <div v-if='(getType(item[vidx]) != "object")'>
                            <span>{{item[vidx]}}</span>
                        </div>
                        <div v-if='(getType(item[vidx]) == "object")'>
                            <div v-for='[key, value] in Object.entries(item[vidx])'>
                                <img v-if='key == "image"' :src='value[1]' :alt='value[0]'/>
                                <span v-if='key != "image"'>{{value}}</span>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default{
        name: 'ItemListTable',
        props:['classes','headers','items', 'caption'],
        data(){
            return{
                ClassObj: this.$props.classes,
                selected: []
            }
        },
        methods:{
            getType(value){
                return typeof value;
            }
        }
    }
</script>